export default __webpack_public_path__ + "static/media/Makro - Turkistan.389f3db7.jpg";